import { Api } from "./Api";
import { Course } from "./Course";
import { Lesson } from "./Lesson";

export class Chapter {
    chapter: IChapter;
    course: Course;
    UPDATE = "https://cms.tybo.co.za/api/cms/update-data-item.php"
    lessons: Lesson[] = [];
    dom: HTMLDivElement;
    lessonsListDom = document.createElement("ul");
    constructor(data: IChapter, course: Course) {
      this.chapter = data;
      this.course = course;
      this.dom = document.createElement("div");
      this.chapter.data.Lessons?.forEach((lesson) => {
        if (lesson) {
          const newLesson = new Lesson(lesson, this);
          this.lessons.push(newLesson);
        }
      });
      this.configure();
    }
    configureAdd(parent: HTMLDivElement) {
      const button = document.createElement("button");
      button.classList.add("btn", "btn-dark-outline", "btn-sm", "mb-3");
      button.innerHTML = `<i class="bi bi-plus"></i> Add lesson`;
      parent.appendChild(button);
      button.onclick = () => this.initAddLesson();
    }
    initAddLesson() {
      if (!this.course.contentSection) return;
      this.course.contentSection.innerHTML = "";
      const form = document.createElement("form");
      form.classList.add("card");
      form.style.maxWidth = "800px";
      const cardBody = document.createElement("div");
      cardBody.classList.add("card-body");
      const title = document.createElement("h4");
      title.classList.add("card-title", "mb-3");
      title.innerHTML = "Add Lesson";
      cardBody.appendChild(title);
      form.appendChild(cardBody);
      form.appendChild(this.createLessonForm());
      this.course.contentSection.appendChild(form);
    }
    createLessonForm(): HTMLElement {
      const group = document.createElement("div");
      group.classList.add("form-group");
      const input = document.createElement("input");
      const label = document.createElement("label");
      label.innerHTML = "Title";
      input.classList.add("form-control", "mb-3");
      group.appendChild(label);
      group.appendChild(input);
      const type = document.createElement("select");
      type.classList.add("form-select", "mb-3");
      const options = ["Text", "Video", "Quiz"];
      options.forEach((option) => {
        const optionElement = document.createElement("option");
        optionElement.innerHTML = option;
        optionElement.value = option;
        type.appendChild(optionElement);
      });
      group.appendChild(type);
      const submit = document.createElement("button");
      submit.classList.add("btn", "btn-primary");
      submit.innerHTML = "Add";
      submit.onclick = () => {
        const newLesson: ILesson = {
          Title: input.value,
          Type: type.value,
          Content: "",
          Link: "",
        };
        this.chapter.data.Lessons.push(newLesson);
        const lesson = new Lesson(newLesson, this);
        this.lessons.push(lesson);
        this.update();
        this.course.contentSection.innerHTML = "";
        this.renderLessons();
      };
      group.appendChild(submit);
      return group;
    }
    configure() {
      this.dom.innerHTML = "";
      this.dom.classList.add("card", "chapter", "mb-3");
      const cardBody = document.createElement("div");
      cardBody.classList.add("card-body");
      const h5 = document.createElement("h5");
      h5.classList.add("card-title", "mb-3");
      h5.innerHTML = this.chapter.data.Name;
      this.lessonsListDom.classList.add("list-group", "mb-3");
      cardBody.appendChild(h5);
      cardBody.appendChild(this.lessonsListDom);
      this.configureAdd(cardBody);
      this.dom.appendChild(cardBody);
      this.renderLessons();
    }
    renderLessons() {
      this.lessonsListDom.innerHTML = "";
      this.lessons.forEach((lesson) => {
        this.lessonsListDom.appendChild(lesson.dom);
      });
    }
  
    update() {
      const api = new Api();
      api.postCall(this.UPDATE, this.chapter).then((data) => {
        console.log("Chapter updated", data);
      });
    }
  }